import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { SchoolActivityInstanceOverview } from '../../../services/flex-daily-overview.service';
import { BulkSignUpForActivitySuccessAction } from '../../school-activity-attendees/actions/school-activity-attendees.actions';
import {
	ClearSchoolActivityInstancesOverviewAction,
	GetSchoolActivityInstancesOverviewSuccessAction,
} from '../actions/school-activities-instances-overview.actions';

export const schoolActivityInstancesOverviewInitialState: EntityState<SchoolActivityInstanceOverview> = {
	ids: [],
	entities: {},
};
export const schoolActivityInstanceOverviewAdapter: EntityAdapter<SchoolActivityInstanceOverview> =
	createEntityAdapter<SchoolActivityInstanceOverview>();

export const schoolActivitiesInstanceOverviewReducer = createReducer(
	schoolActivityInstancesOverviewInitialState,

	on(GetSchoolActivityInstancesOverviewSuccessAction, (state, { instances, overviewDate }) => {
		let idsToRemove: string[] = [];
		if (state.ids.length > 0) {
			idsToRemove = (state.ids as string[]).filter((id: string) => {
				const instance = state.entities[id];
				return instance && !instance.overviewDate.isSame(overviewDate, 'day');
			});
		}
		const newState = schoolActivityInstanceOverviewAdapter.removeMany(idsToRemove, state);
		return schoolActivityInstanceOverviewAdapter.upsertMany(instances, {
			...newState,
		});
	}),
	on(BulkSignUpForActivitySuccessAction, (state, { attendees }) => {
		const existing = Object.values(state.entities).find((e) => e && e.id === attendees[0].activity_instance_id);
		if (existing) {
			existing.attendee_count = existing.attendee_count + attendees.length;
			return schoolActivityInstanceOverviewAdapter.upsertOne(existing, state);
		}
		return state;
	}),
	on(ClearSchoolActivityInstancesOverviewAction, (state, { scheduleType, flexPeriodId, overviewDate }) => {
		let idsToRemove: string[] = [];
		if (scheduleType === 'custom') {
			idsToRemove = (state.ids as string[]).filter((id: string) => {
				const instance = state.entities[id];
				return instance && instance.activity_schedule_type === 'custom';
			});
		} else if (flexPeriodId) {
			idsToRemove = (state.ids as string[]).filter((id: string) => {
				const instance = state.entities[id];
				return instance && instance.flex_period_id !== flexPeriodId;
			});
		}
		return schoolActivityInstanceOverviewAdapter.removeMany(idsToRemove, state);
	})
);
